<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    content-class="editProfile"
  >
    <v-card>
      <v-toolbar dark color="pink">
        <v-btn icon dark @click="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>修改個人資料</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text @click="submit">送出</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-subheader>頭像</v-subheader>
            <div class="d-flex px-4">
              <div 
                class="file-input" 
                @click="$refs[`usericon`].click()"
              >
                <v-icon class="delete" v-if="profile.usericon" @click.stop="profile.usericon = ''">
                  fa-times-circle
                </v-icon>
                <div class="uploadText" v-if="!profile.usericon">
                  <v-icon>fa-plus</v-icon>
                  Select File
                </div>
                <input 
                  type="file" 
                  ref="usericon" 
                  :accept="$accept_file_type.image"
                  v-if="!profile.usericon" 
                  onclick="this.value = null" 
                  @change="uploadImage('usericon')"
                /> 
                <v-img v-if="profile.usericon" :src="profile.usericon.startsWith('data:') ? profile.usericon : $HOST_URL + profile.usericon"/>
              </div>
            </div>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content>
            <v-subheader>桌布</v-subheader>
            <v-responsive class="px-4" max-width="400px">
              <div 
                class="file-input" 
                style="width: 100%;"
                @click="$refs[`wallpaper`].click()"
              >
                <v-icon class="delete" v-if="profile.wallpaper" @click.stop="profile.wallpaper = ''">
                  fa-times-circle
                </v-icon>
                <div class="uploadText" v-if="!profile.wallpaper">
                  <v-icon>fa-plus</v-icon>
                  Select File
                </div>
                <input 
                  type="file" 
                  ref="wallpaper"
                  :accept="$accept_file_type.image"
                  v-if="!profile.wallpaper" 
                  onclick="this.value = null" 
                  @change="uploadImage('wallpaper')"
                /> 
                <v-img v-if="profile.wallpaper" :src="profile.wallpaper.startsWith('data:') ? profile.wallpaper : $HOST_URL + profile.wallpaper"/>
              </div>
            </v-responsive>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content>
            <v-subheader>興趣</v-subheader>
            <v-subheader>
              <v-text-field dense v-model="profile.interest" :rules="[$rules.notEmpty]"></v-text-field>
            </v-subheader>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content>
            <v-subheader>城市</v-subheader>
            <v-subheader>
              <v-text-field dense v-model="profile.city" :rules="[$rules.notEmpty]"></v-text-field>
            </v-subheader>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content>
            <v-subheader>職業</v-subheader>
            <v-subheader>
              <v-select
                v-model="profile.job"
                dense
                placeholder="選擇職業"
                :items="seller_job_types"
                item-text="name"
                item-value="num"
              ></v-select>
            </v-subheader>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content>
            <v-subheader>自我介紹</v-subheader>
            <v-textarea 
              dense 
              outlined 
              v-model="profile.self_intro" 
              :rules="[$rules.notEmpty]" 
              hide-details
              class="px-4"
            ></v-textarea>
          </v-list-item-content>
        </v-list-item>

      </v-list>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  data() {
    return {
      dialog: false,
      profile: {}
    }
  },
  computed: {
    ...mapState('seller', ['seller']),
    ...mapState('global', ['seller_job_types']),
    formIsValid() {
      return (
        this.$rules.notEmpty(this.profile.interest) &&
        this.$rules.notEmpty(this.profile.city) &&
        this.$rules.notEmpty(this.profile.job) &&
        this.$rules.notEmpty(this.profile.self_intro) &&
        this.$rules.notEmpty(this.profile.usericon)
      )
    },
  },
  watch: {
    dialog(newValue) {
      if(!newValue) {
        Object.assign(this.$data, this.$options.data.apply(this))
      }
      else {
        this.profile = this.$func.deepCopy(this.seller)
      }
    }
  },
  methods: {
    async uploadImage(data) {
      let image = event.target.files[0]
      if(!await this.$func.fileValidation(image)) {
        return
      }
      let fileReader = new FileReader()
      this.profile[data] = await this.$func.fileToBase64(image)
      this.$forceUpdate()
    },
    submit() {
      if(!this.formIsValid) {
        return
      }
      // 只發送表單中有的欄位，避免發送不相關的資料
      let updateData = {
        interest: this.profile.interest,
        city: this.profile.city,
        job: this.profile.job,
        self_intro: this.profile.self_intro,
        wallpaper: this.profile.wallpaper && this.profile.wallpaper.startsWith('data:') ? this.profile.wallpaper : null,
        usericon: this.profile.usericon && this.profile.usericon.startsWith('data:') ? this.profile.usericon : null
      }
      this.$root.$emit('loading', true)
      this.axios.put(`/portal/me`, updateData).then(response => {
        this.$root.$emit('alert', 'success', '更新成功')
        this.$store.dispatch('seller/getSellerInformation')
        this.dialog = false
      }).catch(() => {
        this.$root.$emit('alert', 'error', '更新失敗')
      }).finally(() => {
        this.$root.$emit('loading', false)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.editProfile {

}
</style>